import React, { useEffect } from "react";
import Slider from "react-slick";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Button } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { Col, Container, Image, Row } from "react-bootstrap";
import { ImageUrl } from "../../../../../Helpers/request";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BannerSlider = () => {
  const history = useHistory();
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    }
  };
  const banner = localStorage.getItem("bw-bannerdata")
    ? JSON.parse(localStorage.getItem("bw-bannerdata"))
    : [];
  const bannerimg = isMobileOnly ? banner[0]?.mobile_image : banner[0]?.image;

  // console.log("banner", banner);
  return (
    <>
      <Slider
        className="rcs_slider_img banner-slider banner-container"
        {...settings}
      >
        {Array(1)
          .fill()
          .map((val, index) => (
            <div>
              <div className="banner-thumb">
                <Image src={`${ImageUrl}theme/venice/banner.webp`} alt="Fine Jewelry" />
              </div>

              <div className="banner-info animated text-right">
                <div className="container slider_extra_1">
                  <h2 className="title48 font-normal dark">Fine Jewelry</h2>
                  <p className="title14 hide-mob">
                    Explore the latest Fine Jewelry
                  </p>
                  <Link to="#" className="btn white title18">
                    Shop Fine Jewelry
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </Slider>
      {/* {banner?.map((val, index) => (
        <div
          className="rcs_hero_slider"
          style={{
            backgroundImage: `url(${
              isMobileOnly ? val?.mobile_image : val?.image
            })`,
          }}
        >
          <div className="rcs_hero_img">
            <Container fluid>
              <Row className="m-auto w-100">
                <Col md={9} className="m-auto">
                  <div
                    className={
                      isMobile ? "text-center" : val.text_direction_class
                    }
                  >
                    <h1 data-aos="fade-up-left" data-aos-duration="700">
                      {val.title}
                    </h1>
                    <p
                      data-aos="fade-up-left"
                      data-aos-duration="1200"
                      data-aos-delay="300"
                    >
                      {val.short_text}
                    </p>
                    <Button
                      data-aos="fade-up-left"
                      data-aos-duration="1800"
                      data-aos-delay="400"
                      onClick={() => {
                        history.push("/" + val.btn_link);
                      }}
                      variant="outline-dark"
                    >
                      {val.btn_text}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ))} */}
    </>
  );
};

export default BannerSlider;
